import { AgentSearchConfig } from '@tenants/types/tenant';

export const agentSearchConfig: AgentSearchConfig = {
  headerImage: {
    mobileSrc: '/next/assets/images/agent-search/exp-mobile-banner-white-flag.jpg',
    src: '/next/assets/images/agent-search/exp-banner-white-flag.jpg',
    alt: 'Commercial real estate background',
  },
  agentTypeName: 'Commercial Expert',
  featuredAgentDescriptor: 'Commercial',
  pageTitle: 'Find Your Commercial Real Estate Expert',
  showCountrySelect: false,
};